import { Booking } from '@views/booking/booking'
import { BookingConfirmation } from '@views/booking_confirmation/booking_confirmation'
import { DatesSelection } from '@views/dates_selection/dates_selection'
import { DetailsPolicies } from '@views/details_policies/details_policies'
import { VerificationModal } from '@views/details_policies/verification_modal'
import { GroomingWizard } from '@views/grooming_wizard/groomer_wizard'
import { HomePage } from '@views/home_page'
import { NotFound } from '@views/not_found/not_found'
import { Payment } from '@views/payment'
import { PrivacyPolicy } from '@views/privacy_policy/privacy_policy'
import { Agreements } from '@views/profile/agreements/agreements'
import { Contracts } from '@views/profile/agreements/contracts'
import { Bookings } from '@views/profile/bookings/bookings'
import { Cameras } from '@views/profile/cameras/cameras'
import { ProfileContactsAdd, ProfileContactsEdit } from '@views/profile/contacts/form'
import { ProfileContactsList } from '@views/profile/contacts/list'
import { Memberships } from '@views/profile/memberships/memberships'
import { MyProfileEdit } from '@views/profile/myprofile/edit'
import { MyProfile } from '@views/profile/myprofile/myprofile'
import { ProfilePackages } from '@views/profile/packages/list'
import { PaymentWallet } from '@views/profile/payment/payment'
import { MyPetsAdd, MyPetsEdit } from '@views/profile/pets/form'
import { MyPets } from '@views/profile/pets/list'
import { ReportCards } from '@views/profile/report_cards/report_cards'
import { PurchaseHistory } from '@views/purchase_history/purchase_history'
import { PurchaseSummary } from '@views/purchase_summary/purchase_summary'
import { RedirectPage } from '@views/redirect_page/redirect_page'
import { SearchOffers } from '@views/search_offers/search_offers'
import { SearchPetAddOns } from '@views/search_pet_addons/search_pet_addons'
import { SearchRoomAddOns } from '@views/search_room_addons/search_room_addons'
import { SignIn } from '@views/signin/signin'
import { TemperTest } from '@views/temper_test/temper_test'
import { RedirectWithParams } from 'components-ui/src/shared/routes'
import type { TRouteConfig, TRouteNames, TRoutesOpt } from './types'

export const routes = {
  // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-[ GENERAL ]
  homePage: {
    uid: '',
    title: 'Home Page',
    path: '/',
    component: HomePage,
    section: 'pages',
    preResolve: true,
    authenticated: false,
  },
  locationHome: {
    uid: '',
    title: '',
    path: '/:accountName',
    // component: () => <RedirectWithParams to={(params) => `/${params.accountName}/search/boarding/pets`} />,
    component: RedirectPage,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  signIn: {
    uid: '',
    title: 'Sign In',
    path: '/:accountName/signin',
    component: SignIn,
    section: 'noHeaderPages',
    preResolve: true,
    authenticated: false,
  },
  searchServiceType: {
    uid: '',
    title: 'Booking Home',
    path: '/:accountName/search/:serviceTypeName/pets',
    component: Booking,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  searchOffersResults: {
    uid: '',
    title: 'Offers Search Results',
    path: '/:accountName/search/:serviceTypeName/offers',
    component: SearchOffers,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  searchRoomAddOns: {
    uid: '',
    title: 'Offer Room AddOns',
    path: '/:accountName/search/:serviceTypeName/room-addons',
    component: SearchRoomAddOns,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  searchPetAddOns: {
    uid: '',
    title: 'Offer Pet AddOns',
    path: '/:accountName/search/:serviceTypeName/pet-addons',
    component: SearchPetAddOns,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  loginCheck: {
    uid: '',
    title: 'Pet Owner Verification',
    path: '/:accountName/search/:serviceTypeName/verification',
    component: VerificationModal,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  detailsPolicies: {
    uid: '',
    title: 'DetailsAndPolicies',
    path: '/:accountName/booking/details-policies',
    component: DetailsPolicies,
    section: 'offers',
    preResolve: false,
    authenticated: true,
  },
  purchaseHistory: {
    uid: '',
    title: 'Purchase History',
    path: '/:accountName/account/bookings/purchases',
    component: PurchaseHistory,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummary: {
    uid: '',
    title: 'Purchase Summary',
    path: '/:accountName/account/bookings/:bookingId',
    component: PurchaseSummary,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseHistory_legacy: {
    uid: '',
    title: 'Purchase History',
    path: `/kennels/:accountName/bookings`,
    component: () => <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/purchases`} />,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummary_legacy: {
    uid: '',
    title: 'Purchase Summary',
    path: `/kennels/:accountName/bookings/:bookingId/:shortId`,
    component: () => (
      <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/${params.bookingId}`} />
    ),
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummaryCancel_legacy: {
    uid: '',
    title: 'Purchase Summary',
    path: `/kennels/:accountName/cancel-reservation/:bookingId`,
    component: () => (
      <RedirectWithParams to={(params) => `/${params.accountName}/account/bookings/${params.bookingId}`} />
    ),
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  rest_legacy: {
    uid: '',
    title: '',
    path: `/kennels/:accountName/*`,
    component: () => <RedirectWithParams to={(params) => `/${params.accountName}`} />,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  datesSelection: {
    uid: '',
    title: 'Dates Selection',
    path: '/:accountName/search/:serviceTypeName/dates',
    component: DatesSelection,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  temperTest: {
    uid: '',
    title: 'Temperamental Test',
    path: '/:accountName/search/:serviceTypeName/temper-test',
    component: TemperTest,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  groomingWizard: {
    uid: '',
    title: 'Grooming Wizard',
    path: '/:accountName/search/:serviceTypeName/grooming',
    component: GroomingWizard,
    section: 'offers',
    preResolve: false,
    authenticated: true,
  },
  paymentForm: {
    uid: '',
    title: 'Payment',
    path: '/:accountName/booking/payment',
    component: Payment,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  paymentSummary: {
    uid: '',
    title: 'Payment Summary',
    path: '/:accountName/booking/confirmation/:orderId',
    component: BookingConfirmation,
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  privacyPolicy: {
    uid: '',
    title: 'Privacy Policy',
    path: '/:accountName/privacy-policy',
    component: PrivacyPolicy,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  profile: {
    uid: '',
    title: '',
    path: '/:accountName/profile',
    component: () => <RedirectWithParams to={(params) => `/${params.accountName}/profile/my-profile`} />,
    section: 'pages',
    preResolve: false,
    authenticated: true,
  },
  myprofile: {
    uid: '',
    title: 'MyProfile',
    path: '/:accountName/profile/my-profile',
    component: MyProfile,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  myprofileEdit: {
    uid: '',
    title: 'MyProfile',
    path: '/:accountName/profile/my-profile/edit',
    component: MyProfileEdit,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePet: {
    uid: '',
    title: 'Profile Pet',
    path: '/:accountName/profile/pets',
    component: MyPets,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePetEdit: {
    uid: '',
    title: 'Profile Pet',
    path: '/:accountName/profile/pets/:lppId',
    component: MyPetsEdit,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePetAdd: {
    uid: '',
    title: 'Profile Add',
    path: '/:accountName/profile/pets/add',
    component: MyPetsAdd,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileCameras: {
    uid: '',
    title: 'Profile Cameras',
    path: '/:accountName/profile/cameras',
    component: Cameras,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileBookings: {
    uid: '',
    title: 'Profile Bookings',
    path: '/:accountName/profile/bookings',
    component: Bookings,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileReportCards: {
    uid: '',
    title: 'Profile Report Cards',
    path: '/:accountName/profile/report-cards',
    component: ReportCards,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePayments: {
    uid: '',
    title: 'Profile Payments',
    path: '/:accountName/profile/payments',
    component: PaymentWallet,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileMemberships: {
    uid: '',
    title: 'Profile Memberships',
    path: '/:accountName/profile/memberships',
    component: Memberships,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePackages: {
    uid: '',
    title: 'Profile Packages',
    path: '/:accountName/profile/packages',
    component: ProfilePackages,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileAgreements: {
    uid: '',
    title: 'Profile Agreements',
    path: '/:accountName/profile/agreements',
    component: Agreements,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContracts: {
    uid: '',
    title: 'Profle Agreements',
    path: '/:accountName/profile/contracts/:contractId',
    component: Contracts,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContacts: {
    uid: '',
    title: 'Profile Contacts',
    path: '/:accountName/profile/contacts',
    component: ProfileContactsList,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContactsEdit: {
    uid: '',
    title: 'Profile Contacts Edit',
    path: '/:accountName/profile/contacts/:contactId',
    component: ProfileContactsEdit,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContactsAdd: {
    uid: '',
    title: 'Profile Contacts Add',
    path: '/:accountName/profile/contacts/add',
    component: ProfileContactsAdd,
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  notFound: {
    uid: '',
    title: 'Not Found',
    path: '/:accountName/not-found',
    component: NotFound,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
}

export const routeKeys = Object.keys(routes as TRoutesOpt) as TRouteNames[]
// sets uid as the name of the route
routeKeys.forEach((k) => (routes[k].uid = k))

export const routesBySection = routeKeys.reduce(
  (acc, k) => {
    acc[routes[k].section] = acc[routes[k].section] || []
    acc[routes[k].section].push(routes[k] as TRouteConfig)
    return acc
  },
  {} as Record<string, TRouteConfig[]>
)
